import { Shadow, TableItem, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesReserveRatesResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { pensionIRRateStatememntsWidthCols } from '../../../../../../constants';
import { validateAndFormatValue } from '../../../../Table/constants';

interface DetailsIRRateItemProps {
  item: ResponsesReserveRatesResponse;
}

export const DetailsIRRateItem: React.FC<DetailsIRRateItemProps> = ({ item }) => {
  const aliquot = validateAndFormatValue(item?.aliquot, 'percentage');
  const reserve = validateAndFormatValue(item?.reserve, 'money');
  const netReserve = validateAndFormatValue(item?.netReserve, 'money');

  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return (
      <Box marginBottom={Spacing['inset.quarck']}>
        <Shadow level={3} borderRadius={BoxRadius.sm}>
          <VStack
            space={Spacing['inset.nano']}
            borderRadius={BoxRadius.sm}
            p={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Aliquota incidente(%)
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {aliquot}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Reserva(R$)
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {reserve}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Reserva liquida(R$)
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {netReserve}
              </Text>
            </HStack>
          </VStack>
        </Shadow>
      </Box>
    );
  }

  return (
    <HStack
      marginBottom={Spacing['inset.nano']}
      alignItems="center"
      justifyContent="space-between"
      py={Spacing['inline.xxxs']}>
      <TableItem
        testId="statement-pension-ir-rate-item-incidentRate"
        width={pensionIRRateStatememntsWidthCols.incidentRate.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {aliquot}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-ir-rate-item-reserve"
        width={pensionIRRateStatememntsWidthCols.reserve.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {reserve}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-ir-rate-item-netReserve"
        width={pensionIRRateStatememntsWidthCols.netReserve.desktop}>
        <Box w={'full'}>
          <Text
            fontSize={Typography['fontsize.xs']}
            noOfLines={1}
            variant={'regular'}
            textAlign={'end'}>
            {netReserve}
          </Text>
        </Box>
      </TableItem>
    </HStack>
  );
};
